<template>
	<!-- Vue Material Switch -->
	<!-- https://vuematerial.io/components/switch -->
	<span>
		<md-switch
			:class="{'ui-switch--large': large}"
			:disabled="disabled"
			:value="!value"
			class="ui-switch"
			@change="() => {
				$emit('input', !value)
				$emit('change', !value)
			}"
		>
			{{ label }}
		</md-switch>
		<md-tooltip v-if="tooltip">{{ tooltip }}</md-tooltip>
	</span>
</template>

<script>
export default {
	name: "SwitchButton",
	props: {
		disabled: {
			type: Boolean,
			default: false,
			required: false
		},
		label: {
			type: String,
			default: "",
			required: false
		},
		large: {
			type: Boolean,
			default: false,
			required: false
		},
		tooltip: {
			type: String,
			default: "",
			required: false
		},
		value: {
			type: Boolean,
			required: true
		}
	}
};
</script>

<style lang="scss" scoped>
$md-switch-width: 64px;
$md-switch-height: 26px;
$md-switch-size: 34px;
$md-switch-touch-size: 72px;

// add pseudo element to set opaque background on switch, workaround since the switch container (track)
// background color is a fixed color generated at compile time by Vue Material
.ui-switch {
	/deep/ .md-switch-container {
		background-color: transparent !important;
		&::before {
			background-color: rgba(0, 0, 0, 0.38);
			content: "";
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			border-radius: $md-switch-height;
			transition: inherit;
		}
	}
	&.md-checked {
		/deep/ .md-switch-container {
			background-color: transparent !important;
			&::before {
				background-color: var(--ui-theme-secondary);
				opacity: 0.38;
			}
		}
	}
}

.ui-switch--large {
	/deep/ .md-switch-container {
		width: $md-switch-width;
		min-width: $md-switch-width;
		height: $md-switch-height;
		border-radius: $md-switch-height;
		.md-switch-thumb {
			width: $md-switch-size;
			height: $md-switch-size;

			&:before {
				width: $md-switch-touch-size;
				height: $md-switch-touch-size;
			}

			.md-ripple {
				width: $md-switch-touch-size !important;
				height: $md-switch-touch-size !important;
			}
		}
	}
	/deep/ .md-switch-label {
		height: $md-switch-size;
		line-height: $md-switch-size;
		margin: 0;
	}
	&.md-checked {
		/deep/ .md-switch-thumb {
			transform: translate3d(30px, 0, 0);
		}
	}
}
</style>
